export function calculateColumnTotal(data, columnName) {
  if (!Array.isArray(data)) return 0;

  return data.reduce((sum, row) => {
    const value = parseFloat(row?.[columnName]);
    return sum + (isNaN(value) ? 0 : value);
  }, 0);
}
export const NumberFormat = (value, Digits) => {
  const num = parseFloat(value);
  if (isNaN(num)) {
    return "0.00"; // or "" if you prefer empty
  }

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: Digits || 2,
    maximumFractionDigits: Digits || 2,
  }).format(num);
};

export function FirstColumnData(data, columnName) {
  let total = 0;

  const firstRow = data[0]; // Get the first row of data

  const columnValue = parseFloat(firstRow[columnName]);
  total += isNaN(columnValue) ? 0 : columnValue;

  return total;
}
